import {
  GET_UNIT_LIST_REQUEST,
  GET_UNIT_LIST_SUCCESS,
  GET_UNIT_LIST_FAILURE,
  GET_UNIT_DETAILS_REQUEST,
  GET_UNIT_DETAILS_FAILURE,
  GET_UNIT_DETAILS_SUCCESS,
  GET_UNIT_STATUS_REQUEST,
  GET_UNIT_STATUS_FAILURE,
  GET_UNIT_STATUS_SUCCESS,
  CLEAR_UNIT_STATUS,
  GET_UNIT_EVENTS_LIST_REQUEST,
  GET_UNIT_EVENTS_LIST_FAILURE,
  GET_UNIT_EVENTS_LIST_SUCCESS,
  GET_UNIT_POWERFLOW_DETAILS_SUCCESS,
  GET_UNIT_DEBUG_REQUEST,
  GET_UNIT_DEBUG_SUCCESS,
  GET_UNIT_DEBUG_FAILURE,
  UNIT_COMMAND_REQUEST,
  UNIT_COMMAND_FAILURE,
  UNIT_COMMAND_SUCCESS,
  GET_UNIT_LOGS_REQUEST,
  GET_UNIT_LOGS_SUCCESS,
  GET_UNIT_LOGS_FAILURE,
  GET_UNIT_TASK_LOGS_REQUEST,
  GET_UNIT_TASK_LOGS_SUCCESS,
  GET_UNIT_TASK_LOGS_FAILURE,
  CLEAR_UNIT_DEBUG,
  GET_UNIT_OPERATION_LIST_REQUEST,
  GET_UNIT_OPERATION_LIST_SUCCESS,
  GET_UNIT_OPERATION_LIST_FAILURE,
  GET_UNIT_DETAILS_MORE_REQUEST,
  GET_UNIT_DETAILS_MORE_SUCCESS,
  GET_UNIT_DETAILS_MORE_FAILURE,
  POST_UNIT_OPERATION_REQUEST,
  POST_UNIT_OPERATION_FAILURE,
  POST_UNIT_OPERATION_SUCCESS,
  DELETE_UNIT_OPERATION_REQUEST,
  DELETE_UNIT_OPERATION_SUCCESS,
  DELETE_UNIT_OPERATION_FAILURE,
  GET_UNIT_ENERGY_USAGE_SUMMARY_REQUEST,
  GET_UNIT_ENERGY_USAGE_SUMMARY_SUCCESS,
  GET_UNIT_ENERGY_USAGE_SUMMARY_FAILURE,
  GET_UNIT_ENERGY_USAGE_HISTORY_REQUEST,
  GET_UNIT_ENERGY_USAGE_HISTORY_SUCCESS,
  GET_UNIT_ENERGY_USAGE_HISTORY_FAILURE,
  GET_REGULATORY_CONTROL_SUCCESS,
  GET_REGULATORY_CONTROL_FAILURE,
  GET_REGULATORY_CONTROL_NOMINATION_REQUEST,
  GET_REGULATORY_CONTROL_NOMINATION_SUCCESS,
  GET_REGULATORY_CONTROL_NOMINATION_FAILURE,
  GET_REGULATORY_CONTROL_LIST_REQUEST,
  GET_REGULATORY_CONTROL_LIST_FAILURE,
  GET_REGULATORY_CONTROL_LIST_SUCCESS,
  GET_UNIT_OPERATION_DETAILS_SUCCESS,
  GET_UNIT_OPERATION_DETAILS_REQUEST,
  GET_UNIT_OPERATION_DETAILS_FAILURE,
  GET_UNIT_LIFECYCLE_STATE_SUCCESS,
  UPDATE_UNIT_LIFECYCLE_STATE_REQUEST,
  UPDATE_UNIT_LIFECYCLE_STATE_SUCCESS,
  UPDATE_UNIT_LIFECYCLE_STATE_FAILURE,
  OVERRIDE_PRICE_REFERENCE,
  GET_UNIT_SETTING_REQUEST,
  GET_UNIT_SETTING_SUCCESS,
  GET_UNIT_SETTING_FAILURE,
  PUT_UNIT_SETTING_REQUEST,
  PUT_UNIT_SETTING_SUCCESS,
  PUT_UNIT_SETTING_FAILURE,
} from "actions/unit";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { isNil, orderBy } from "lodash";
import {
  constructDebugBucket,
  formatPriceExport,
  getOperationMode,
} from "utils/unit";

dayjs.extend(advancedFormat);

const initialSummary = {
  battery_import: 0,
  battery_export: 0,
  solar: 0,
  grid_import: 0,
  grid_export: 0,
  house: 0,
  solar_gen: 0,
  grid_avoided: 0,
  peak_avoided: 0,
  battery_usage: 0,
  grid_usage: 0,
  solar_usage: 0,
  peak: 0,
  off_peak: 0,
  shoulder: 0,
  carbon_use: 0,
  car_use: 0,
  phone_use: 0,
  timestamp: "",
  peak_grid_imports_avoided: 0,
  tou_periods: [],
};

const initialState = {
  loading: false,
  error: {},
  list: [],
  details: {},
  status: {},
  powerflowDetails: {},
  events: [],
  eventsLoading: false,
  debug: {},
  debugLoading: false,
  commandLoading: false,
  logList: [],
  log: {},
  logLoading: false,
  operation: {},
  operationList: [],
  operationLoading: false,
  unitDetailsMore: {},
  summaryLoading: false,
  summary: initialSummary,
  historyLoading: false,
  history: [],
  regulatoryDetailsLoading: false,
  regulatoryDetails: {},
  regulatoryDetailsList: [],
  regulatoryNominationDetailsLoading: false,
  regulatoryNominationDetails: {},
  lifecycleState: {},
  lifecycleStateLoading: false,
  overridePriceReference: null,
  modemUsageLoading: false,
  modemUsage: {},
  setting: {},
  settingLoading: false,
};

export default function unit(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_UNIT_DETAILS_REQUEST:
    case GET_UNIT_LIST_REQUEST:
    case GET_UNIT_STATUS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_UNIT_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: orderBy(payload, ["serial"]).map((it) => {
          return {
            ...it,
            value: it.id,
            label: it.serial,
          };
        }),
      };
    }

    case GET_UNIT_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        details: payload,
      };
    }

    case GET_UNIT_STATUS_SUCCESS: {
      return {
        ...state,
        loading: false,
        status: payload,
        powerflowDetails: {
          ...payload,
          solar: payload?.solar_power,
          hotwater: payload?.hotwater_power,
          battery: payload?.battery_power,
          grid: payload?.grid_power,
          grid_present: payload?.grid_present,
          online: payload?.online,
          soc: payload?.battery_soc,
          ev: payload?.ev1_power,
          ev_status: payload?.ev1_status,
          price_export: formatPriceExport(payload.price_export),
        },
      };
    }

    case GET_UNIT_LIST_FAILURE:
    case GET_UNIT_DETAILS_FAILURE:
    case GET_UNIT_STATUS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_UNIT_POWERFLOW_DETAILS_SUCCESS: {
      return {
        ...state,
        status: payload,
        powerflowDetails: {
          ...payload,
          solar: payload?.solar_power,
          hotwater: payload?.hotwater_power,
          battery: payload?.battery_power,
          grid: payload?.grid_power,
          grid_present: payload?.grid_present,
          online: payload?.online,
          soc: payload?.battery_soc,
          ev: payload?.ev1_power,
          ev_status: payload?.ev1_status,
          price_export: formatPriceExport(payload.price_export),
        },
      };
    }

    case CLEAR_UNIT_STATUS: {
      return {
        ...state,
        status: {},
        log: {},
        logList: [],
        details: {},
        powerflowDetails: {},
        debug: {},
        operation: {},
        operationList: [],
        unitDetailsMore: {},
        summary: initialSummary,
        history: [],
        regulatoryDetails: {},
      };
    }

    case CLEAR_UNIT_DEBUG: {
      return {
        ...state,
        debug: {},
      };
    }

    case GET_UNIT_EVENTS_LIST_REQUEST: {
      return {
        ...state,
        eventsLoading: true,
      };
    }

    case GET_UNIT_EVENTS_LIST_SUCCESS: {
      return {
        ...state,
        eventsLoading: false,
        events: orderBy(payload, ["timestamp"], "desc").map((it, i) => {
          return {
            ...it,
            id: i,
            stopped: it.timestamp,
          };
        }),
      };
    }

    case GET_UNIT_EVENTS_LIST_FAILURE: {
      return {
        ...state,
        eventsLoading: false,
      };
    }

    case GET_UNIT_DEBUG_REQUEST: {
      return {
        ...state,
        debugLoading: true,
      };
    }

    case GET_UNIT_DEBUG_SUCCESS: {
      return {
        ...state,
        debugLoading: false,
        debug: constructDebugBucket(payload),
      };
    }

    case GET_UNIT_DEBUG_FAILURE: {
      return {
        ...state,
        debugLoading: false,
      };
    }

    case UNIT_COMMAND_REQUEST: {
      return {
        ...state,
        commandLoading: true,
      };
    }

    case UNIT_COMMAND_SUCCESS: {
      return {
        ...state,
        commandLoading: false,
      };
    }

    case UNIT_COMMAND_FAILURE: {
      const { source } = payload;
      const obj =
        source === "log"
          ? {
            log: {
              error: "",
            },
          }
          : source === "debug"
            ? {
              debug: {
                error: "",
              },
            }
            : {};

      return {
        ...state,
        commandLoading: false,
        ...obj,
      };
    }

    case GET_UNIT_LOGS_REQUEST: {
      return {
        ...state,
        logLoading: true,
      };
    }

    case GET_UNIT_LOGS_SUCCESS: {
      return {
        ...state,
        logLoading: false,
        log: payload ?? {},
        logList:
          payload?.list.map((it, i) => {
            return {
              ...it,
              id: i,
              message: it.Message,
              severity: it.Severity,
              source: it.Source,
              timestamp: it.Timestamp,
            };
          }) ?? [],
      };
    }

    case GET_UNIT_LOGS_FAILURE: {
      return {
        ...state,
        logLoading: false,
      };
    }

    case GET_UNIT_TASK_LOGS_REQUEST: {
      return {
        ...state,
        taskLogLoading: true,
      };
    }

    case GET_UNIT_TASK_LOGS_SUCCESS: {
      return {
        ...state,
        taskLogLoading: false,
        taskLog: payload ?? {},
        taskLogList:
          payload?.list.map((it, i) => {
            return {
              ...it,
              id: i,
              message: it.Message,
              severity: it.Severity,
              source: it.Source,
              timestamp: it.Timestamp,
            };
          }) ?? [],
      };
    }

    case GET_UNIT_TASK_LOGS_FAILURE: {
      return {
        ...state,
        taskLogLoading: false,
      };
    }

    case POST_UNIT_OPERATION_REQUEST:
    case DELETE_UNIT_OPERATION_REQUEST:
    case GET_UNIT_OPERATION_LIST_REQUEST:
    case GET_UNIT_OPERATION_DETAILS_REQUEST: {
      return {
        ...state,
        operationLoading: true,
      };
    }

    case GET_UNIT_OPERATION_LIST_SUCCESS: {
      return {
        ...state,
        operationLoading: false,
        operationList: payload.map((it) => {
          return {
            ...it,
            mode: getOperationMode(it).label,
            description:
              typeof it?.description === "string" ? it?.description : "",
          };
        }),
      };
    }

    case GET_UNIT_OPERATION_DETAILS_SUCCESS: {
      return {
        ...state,
        operationLoading: false,
        operation: payload,
      };
    }

    case POST_UNIT_OPERATION_SUCCESS:
    case POST_UNIT_OPERATION_FAILURE:
    case DELETE_UNIT_OPERATION_SUCCESS:
    case DELETE_UNIT_OPERATION_FAILURE:
    case GET_UNIT_OPERATION_LIST_FAILURE:
    case GET_UNIT_OPERATION_DETAILS_FAILURE: {
      return {
        ...state,
        operationLoading: false,
      };
    }

    case GET_UNIT_DETAILS_MORE_REQUEST: {
      return {
        ...state,
      };
    }

    case GET_UNIT_DETAILS_MORE_SUCCESS: {
      return {
        ...state,
        unitDetailsMore: payload,
      };
    }

    case GET_UNIT_DETAILS_MORE_FAILURE: {
      return {
        ...state,
      };
    }

    case GET_UNIT_ENERGY_USAGE_SUMMARY_REQUEST: {
      return {
        ...state,
        summaryLoading: true,
      };
    }

    case GET_UNIT_ENERGY_USAGE_SUMMARY_SUCCESS: {
      const summary =
        payload.length > 0
          ? {
            ...initialSummary,
            ...payload[0],
          }
          : initialSummary;

      return {
        ...state,
        summaryLoading: false,
        summary,
      };
    }

    case GET_UNIT_ENERGY_USAGE_SUMMARY_FAILURE: {
      return {
        ...state,
        summaryLoading: false,
      };
    }

    case GET_UNIT_ENERGY_USAGE_HISTORY_REQUEST: {
      return {
        ...state,
        historyLoading: true,
      };
    }

    case GET_UNIT_ENERGY_USAGE_HISTORY_SUCCESS: {
      var running_cost = 0;
      var running_cost_import = 0;
      var running_cost_export = 0;
      return {
        ...state,
        historyLoading: false,
        history: payload
          ? payload.map((it) => {
            return {
              ...it,
              price_export: formatPriceExport(it.price_export),
              cost_cumulative:
                it.cost_net != null ? (running_cost += it.cost_net) : null,
              cost_import_cumulative:
                it.cost_import != null
                  ? (running_cost_import += it.cost_import)
                  : null,
              cost_export_cumulative:
                it.cost_export != null
                  ? (running_cost_export += it.cost_export)
                  : null,
            };
          })
          : [],
      };
    }

    case GET_UNIT_ENERGY_USAGE_HISTORY_FAILURE: {
      return {
        ...state,
        historyLoading: false,
      };
    }

    case GET_REGULATORY_CONTROL_LIST_REQUEST: {
      return {
        ...state,
        regulatoryDetailsLoading: true,
      };
    }

    case GET_REGULATORY_CONTROL_SUCCESS: {
      return {
        ...state,
        regulatoryDetails: payload,
      };
    }

    case GET_REGULATORY_CONTROL_LIST_SUCCESS: {
      return {
        ...state,
        regulatoryDetailsList: payload.map((it, i) => {
          return {
            ...it,
            id: i,
            grid_connection:
              isNil(it?.grid_connection) || it?.grid_connection
                ? "-"
                : "Disconnect",
          };
        }),
        regulatoryDetailsLoading: false,
      };
    }

    case GET_REGULATORY_CONTROL_FAILURE:
    case GET_REGULATORY_CONTROL_LIST_FAILURE: {
      return {
        ...state,
        regulatoryDetailsLoading: false,
      };
    }

    case GET_REGULATORY_CONTROL_NOMINATION_REQUEST: {
      return {
        ...state,
        regulatoryNominationDetailsLoading: true,
      };
    }

    case GET_REGULATORY_CONTROL_NOMINATION_SUCCESS: {
      return {
        ...state,
        regulatoryNominationDetails: payload,
        regulatoryNominationDetailsLoading: false,
      };
    }

    case GET_REGULATORY_CONTROL_NOMINATION_FAILURE: {
      return {
        ...state,
        regulatoryNominationDetailsLoading: false,
      };
    }

    case GET_UNIT_LIFECYCLE_STATE_SUCCESS: {
      return {
        ...state,
        lifecycleState: payload,
      };
    }

    case UPDATE_UNIT_LIFECYCLE_STATE_REQUEST: {
      return {
        ...state,
        lifecycleStateLoading: true,
      };
    }

    case UPDATE_UNIT_LIFECYCLE_STATE_SUCCESS: {
      return {
        ...state,
        lifecycleStateLoading: false,
      };
    }

    case UPDATE_UNIT_LIFECYCLE_STATE_FAILURE: {
      return {
        ...state,
        lifecycleStateLoading: false,
      };
    }

    case OVERRIDE_PRICE_REFERENCE: {
      return {
        ...state,
        overridePriceReference: payload,
      };
    }

    case GET_UNIT_SETTING_REQUEST: {
      return {
        ...state,
        settingLoading: true,
      };
    }

    case GET_UNIT_SETTING_SUCCESS: {
      return {
        ...state,
        settingLoading: false,
        setting: payload,
      };
    }

    case GET_UNIT_SETTING_FAILURE: {
      return {
        ...state,
        settingLoading: false,
      };
    }

    case PUT_UNIT_SETTING_REQUEST: {
      return {
        ...state,
        settingLoading: true,
      };
    }

    case PUT_UNIT_SETTING_SUCCESS:
    case PUT_UNIT_SETTING_FAILURE: {
      return {
        ...state,
        settingLoading: false,
      };
    }

    default:
      return state;
  }
}
